<template>
  <f7-popup id="service1" @popup:open="setPopup" @popup:close="resetPopup">

		<page-nav-bar currentServiceName="MoneyRoad" subNavTitle="New MoneyRoad" :closePopup="true"></page-nav-bar>

    <div class="layoutSubtitle"/>
    <f7-list form id="paymentsForm">
      <f7-list-item class='titleForm'>
        <div>Debtor Information</div>
        <f7-icon id='bookContacts' f7="book"></f7-icon>
      </f7-list-item>
      <f7-list-item>
        <f7-label><span class="color-red">* </span>Debtor Name</f7-label>
        <f7-input id="debtor-name" name="debtorName" placeholder="Debtor name" type="text" v-model="debtorName"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label id="debitorAccount"><span class="color-red">* </span>Debitor Account</f7-label>
        <f7-input id="debtor-bank" name="debtorBankAccount" placeholder="Debtor bank" type="text" v-model="debtorBank"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label><span class="color-red">* </span>Debtor Email</f7-label>
        <f7-input id="debtor-email" name="debtorEmail" placeholder="Debtor email" type="email" v-model="debtorEmail"></f7-input>
      </f7-list-item>
      <f7-list-item class='titleForm'>
        <div>Creditor Infomation</div>
      </f7-list-item>
      <f7-list-item>
        <f7-label id="creditorAccount"><span class="color-red">* </span>Creditor Account</f7-label>
        <f7-input name="creditorBankAccount" v-model="creditorBankName" id="account-input" type="text" placeholder="Creditor bank" @click="accountPicker">
          <!-- option v-for="account in bankAccounts" :key="account.id" :value="account.iban">{{account.name}}</option-->
        </f7-input>
      </f7-list-item>
      <f7-list-item class='titleForm'>
        <div>Global Infomation</div>
      </f7-list-item>
      <f7-list-item>
        <f7-label><span class="color-red">* </span>Remittance</f7-label>
        <f7-input name="remittanceInformation" placeholder="Remittance information" type="text" v-model="remittanceInformation"></f7-input>
      </f7-list-item>
      <f7-list-item id="execDate">
        <f7-label><span class="color-red">* </span>Execution Date</f7-label>
        <f7-input name="executionDate" placeholder="1900-12-12" type="date" v-model="executionDate"></f7-input>
      </f7-list-item>
      <f7-list-item>
        <f7-label><span class="color-red">* </span>Amount (€)</f7-label>
        <f7-input name="amount" placeholder="Amount" type="number" v-model="amount"></f7-input>
      </f7-list-item>
      <f7-list-item checkbox
        name="ImmPmtAccepted"
        value="0"
        :checked="ImmPmtAccepted"
        @click="ImmPmtAccepted=!ImmPmtAccepted"
        title="Debitor allowed to pay immediatelly">
      </f7-list-item>
      <f7-list-item checkbox
        name="modificationAccepted"
        value="0"
        :checked="modificationAccepted"
        @click="modificationAccepted=!modificationAccepted"
        title="Debitor allowed to modify payments">
      </f7-list-item>
      <f7-list-item id="switchItem">
        <f7-input id="switch-input" name="fileSwitch" type="switch" @change="switched" :checked="fromCloud"></f7-input>
        <f7-label>Attachment from Local/Cloud</f7-label>
      </f7-list-item>
      <f7-list-item>
        <f7-label>Reference</f7-label>
        <f7-input name="reference" placeholder="Reference" type="text" v-model="attachementReference"></f7-input>
      </f7-list-item>
      <div id="attachmentInputs">
        <f7-list-item v-if="!fromCloud">
          <input type="file" name="file" id="file" class="inputfile" @change="onFileChange"/>
          <label for="file">Local Attachement</label>
          <f7-input name="filename" :placeholder="attachementName" type="text" v-model="attachementName" readonly></f7-input>
        </f7-list-item>
        <f7-list-item v-else @click="filesPicker">
          <f7-label id="cloud-label">Cloud</f7-label>
          <f7-input name="cloudFile" type="text" :placeholder="attachementName" id="cloud-file-input" readonly>
          </f7-input>
        </f7-list-item>
      </div>
    </f7-list>
    <f7-list>
      <!-- <f7-list-button v-if="accesAccount" link="/account/" title="Login" link-view="#main-page">Login</f7-list-button> -->
      <f7-button icon-f7="compose" class="blueConfirmationButton" color="white" @click="sendPayments">Send</f7-button>
    </f7-list>
  </f7-popup>
</template>

<script>
import moment from 'moment'
import * as JsPDF from 'jspdf'
// import {get} from '@/helpers/api'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
// import PaymentsSentboxPage from '@/pages/services/payments/CMSendboxPage.vue'
// import {getPayments} from '@/helpers/payments'
import {loadPage} from '@/helpers/routing'

export default {
  name: 'writePayments',
  data: () => {
    return {
      debtorName: '',
      debtorBank: '',
      creditorBank: '',
      creditorBankName: '',
      debtorEmail: '',
      remittanceInformation: '',
      executionDate: '',
      amount: '',
      modificationAccepted: false,
      attachement: '',
      attachementName: '',
      attachementReference: '',
      attachementId: '',
      loadingFile: false,
      fromCloud: false,
      bankAccounts: [],
      contacts: [],
      cloudFiles: [],
      ImmPmtAccepted: false,
      cloudDocsPicker: '',
      accountsPicker: ''
    }
  },
  mounted () {
  },
  created () {
    this.$bus.$on('refresh-contact-payments', (data) => {
      this.debtorName = data.debtorName
      this.debtorBank = data.debtorBank
      this.debtorEmail = data.debtorEmail
    })
  },
  components: {
    JsPDF,
    'page-nav-bar': pageNavBar
  },
  watch: {
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader('Loading File')
      } else {
        this.$f7.hidePreloader()
      }
    }
  },
  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 500000) {
        this.createImage(files[0])
        this.attachementName = files[0].name
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 500Kb', 'Maximum file size exceeded')
      }
    },
    switched () {
      this.fromCloud = !this.fromCloud
      this.attachementName = ''
      this.attachement = ''
      this.attachementId = ''
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachementId.toString())
        .then(response => {
          that.attachementName = response.data.document_name
          that.attachement = response.data.document_data
          that.loadingFile = false
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      // get(
      //   'cloudDocument/detail/' + that.attachementId.toString(),
      //   response => {
      //     that.$engine.settings.set({sessionToken: response.headers['x-session-token']})
      //     that.attachementName = response.data.document_name
      //     that.attachement = response.data.document_data
      //     that.loadingFile = false
      //   },
      //   error => {
      //     errorMessageAlert(error, that)
      //   },
      //   {
      //     headers: {
      //       'X-Session-Token': that.$settings.sessionToken
      //     }
      //   }
      // )
    },
    createImage (file) {
      var reader = new FileReader()
      var vm = this
      reader.onload = (e) => {
        vm.attachement = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.attachement = ''
    },
    convertDateFormat () {
      this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
    },
    sendPayments: function () {
      let ImmPmtAcc = this.ImmPmtAccepted ? 'true' : 'false'
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.modificationAccepted ? 'true' : 'false'
      const that = this
      if (that.creditorBankAccount !== '' &&
          that.debtorName !== '' &&
          that.debtorBankAccount !== '' &&
          that.debtorEmail !== '' &&
          that.remittanceInformation !== '' &&
          that.executionDate !== '' &&
          that.executionDate !== '' &&
          that.amount !== '' &&
          that.modificationAccepted !== '') {
        this.convertDateFormat()
      //   post(
      // 'payments',
      // response => {
      //   that.status = response.status
      //   if (response.status === 200) {
      //     that.$engine.settings.set({sessionToken: response.headers['x-session-token']})
      //     that.$bus.$emit('payments-sent')
      //     that.$f7.alert('', 'Payments Sent', function () {
      //       getPayments({direction: 1}, that, function (payments) {
      //         that.$bus.emit('refresh-sendbox-list-cache', payments)
      //         that.$f7.closeModal()
      //         loadPage(that, {url: '/inbox/1'})
      //       })
      //     })
      //   }
      // },
      // error => {
      //   errorMessageAlert(error, that)
      // },
      //     {
      //       CreditorIdentifier: that.$settings.currentAccount.identifier,
      //       CreditorBankAccount: that.creditorBank,
      //       DebtorName: that.debtorName,
      //       DebtorBankAccount: that.debtorBank,
      //       DebtorIdentifier: that.debtorEmail,
      //       RemittanceInformation: that.remittanceInformation,
      //       ImmPmtAccepted: ImmPmtAcc,
      //       PymtNtr: payNat,
      //       RequestedExecutionDate: that.executionDate,
      //       Amount: that.amount,
      //       ModificationAccepted: payModAcc,
      //       AttachmentName: that.attachementName,
      //       AttachmentReference: that.attachementReference,
      //       AttachmentData: that.attachement
      //     },
      //     {
      //       headers: {
      //         'X-Session-Token': that.$settings.sessionToken
      //       }
      //     })
        that.$engine.services.payments
          .create({
            CreditorIdentifier: this.$engine.user.get().identifier,
            CreditorBankAccount: that.creditorBank,
            DebtorName: that.debtorName,
            DebtorBankAccount: that.debtorBank,
            DebtorIdentifier: that.debtorEmail,
            RemittanceInformation: that.remittanceInformation,
            ImmPmtAccepted: ImmPmtAcc,
            PymtNtr: payNat,
            RequestedExecutionDate: that.executionDate,
            Amount: that.amount,
            ModificationAccepted: payModAcc,
            AttachmentName: that.attachementName,
            AttachmentReference: that.attachementReference,
            AttachmentData: that.attachement
          })
          .then(response => {
            that.status = response.status
            if (response.status === 200) {
              // that.$engine.settings.set({sessionToken: response.headers['x-session-token']})
              that.$bus.$emit('payments-sent')
              that.$f7.alert('', 'Payments Sent', function () {
                // that.$engine.services.payments.update(1, 10, 1, {status: that.$settings.status, date: that.$settings.date, cdtrOrDbtrNm: that.$settings.cdtrOrDbtrNm})
                // .then(resp => {
                that.$f7.closeModal()
                loadPage(that, {url: '/inbox/1'})
                // })
                // getPayments({direction: 1}, that, function (payments) {
                //   that.$bus.emit('refresh-sendbox-list-cache', payments)
                //   loadPage(that, {url: '/inbox/1'})
                // })
              })
            }
          })
          .catch(error => {
            errorMessageAlert(error, that)
          })
      } else {
        that.$f7.alert('', 'Data missing')
      }
    },
    accountPicker (e) {
      e.stopPropagation()
      this.accountsPicker.open()
    },
    filesPicker (e) {
      e.stopPropagation()
      if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    contactsPicker (e) {
      e.stopPropagation()
      if (this.loadingFile === true) { return }
      this.contactsPicker.open()
    },
    setPopup () {
      let that = this
      // this.contacts = this.$settings.currentAccount.contacts
      this.contacts = this.$engine.contacts.get()
      // this.bankAccounts = this.$settings.currentAccount.ibans
      // this.cloudFiles = this.$settings.currentAccount.docs
      this.bankAccounts = this.$engine.bankAccounts.get()
      this.cloudFiles = this.$engine.attachments.get()
      this.loadingFile = false
      this.fromCloud = false
      this.executionDate = moment().format('YYYY-MM-DD')
      this.creditorBank = ''
      this.creditorBankName = ''
      that.attahmentName = 'File'
      if (typeof (this.$settings.preChargedFile) !== 'undefined') {
        if (this.$settings.preChargedFile.fromCloudList === true) {
          this.fromCloud = true
          this.attachementId = this.$settings.preChargedFile.id
          this.attachementName = this.$settings.preChargedFile.name
          this.attachementReference = this.$settings.preChargedFile.reference
          this.attachement = this.$settings.preChargedFile.data
          this.debtorName = this.$settings.preChargedFile.debtorName
          this.executionDate = this.$settings.preChargedFile.executionDate
          this.amount = this.$settings.preChargedFile.amount
          for (var i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].name === this.$settings.preChargedFile.debtorName) {
              that.debtorName = this.contacts[i].name
              that.debtorBank = this.contacts[i].iban
              that.debtorEmail = this.contacts[i].login
            }
          }
        }
      }
      let contactsMap = this.contacts.map(function (obj) {
        let rObj = {}
        rObj[obj.label] = obj
        return rObj
      })
      let contactsMapObj = Object.assign({}, ...contactsMap)
      this.contactsPicker = this.$f7.picker({
        input: '#bookContacts',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: Object.keys(contactsMapObj)
          }
        ],
        onClose: function (p) {
          // var data = []
          that.debtorName = contactsMapObj[p.value].name
          that.debtorBank = contactsMapObj[p.value].iban
          that.debtorEmail = contactsMapObj[p.value].login
          that.contacts = contactsMapObj[p.value]
        }
      })
      let ibansMap = this.bankAccounts.map(function (obj) {
        let rObj = {}
        rObj[obj.name] = obj.iban
        return rObj
      })
      let ibansMapObj = Object.assign({}, ...ibansMap)
      this.accountsPicker = this.$f7.picker({
        input: '#account-input',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: Object.keys(ibansMapObj)
          }
        ],
        onClose: function (p) {
          that.creditorBank = ibansMapObj[p.value]
        },
        onOpen: function (p) {
          that.creditorBankName = p.value
        }
      })
      let filesMap = this.cloudFiles.map(function (obj) {
        let rObj = {}
        rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
        return rObj
      })
      let filesMapObj = Object.assign({}, ...filesMap)
      this.cloudDocsPicker = this.$f7.picker({
        input: '#cloud-file-input',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: Object.keys(filesMapObj)
          }
        ],
        onClose: function (p) {
          if (filesMapObj[p.value].id !== that.attachementId) {
            that.attachementId = filesMapObj[p.value].id
            that.cloudFileSel()
          }
        },
        onOpen: function (p) {
          that.attachementName = p.value
        }
      })
    },
    resetPopup () {
      this.attachementName = 'File'
      this.attachment = ''
      this.debtorName = ''
      this.debtorBank = ''
      this.creditorBank = ''
      this.debtorEmail = ''
      this.remittanceInformation = ''
      this.executionDate = ''
      this.amount = ''
      this.attachementReference = ''
      this.modificationAccepted = false
      this.attachementId = ''
      this.loadingFile = ''
      this.fromCloud = ''
      this.bankAccounts = ''
      this.contacts = []
      this.cloudFiles = []
      this.ImmPmtAccepted = false
      this.cloudDocsPicker = ''
      this.accountsPicker = ''
      let attachmentObj = {
        fromCloudList: false,
        id: 0,
        name: '',
        data: '',
        amount: 0,
        reference: '',
        debtorName: '',
        executionDate: ''
      }
      this.$engine.settings.set({preChargedFile: attachmentObj})
    }
  }
}
</script>
<style>
.titleForm {
  background: #f7f7f7;
  margin-top: -1px;
  padding: 4px 15px;
  white-space: nowrap;
  position: relative;
  max-width: 100%;
  text-overflow: ellipsis;
  overflow: hidden;
  color: #8e8e93;
  z-index: 15;
}
#paymentsForm .item-title.label {
	overflow: initial;
  white-space: normal;
}
#switchItem .item-title.label {
  width: 70%;
  padding-right: 10%;
  margin-left: 0%;
  text-align: left;
}
#switchItem .item-input {
  width: 0%;
  padding-right: 0%;
  margin-right: 0%;
}
#execDate .item-title.label {
  width: 50%;
}
#debitorAccount {
  width: 40%;
}
#creditorAccount {
  width: 45%;
}
/* .inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	position: absolute;
	z-index: -1;
}
.inputfile + label {
    color: #12bcf1;
    width: 56%;
    background-color: white;
    display: inline-block;
} */
#cloud-label {
    color: #12bcf1;
    width: 30%;
    background-color: #e6e7e8;
    padding: 3px 3px 3px 3px;
    text-align: center;
    display: inline-block;
    border-style: solid;
    border-width: 1px;
    border-radius: 5px;
    border-color: #12bcf1;
}
#cloud-file-input {
  padding-left: 10%;
}
</style>



// WEBPACK FOOTER //
// CMPayments.vue?011bdb7e